<script>
import EffConTable from "../components/TeacherPage/EffConTable.vue";
const PersonEffConDialog = () => import("../../Dialog/PersonEffConDialog.vue");
import Loading from "../Loading.vue";
import {mapActions, mapGetters, mapState} from "vuex";
import EffectiveContractAutoCalculationDetailDialog
  from "../../Dialog/EffectiveContractAutoCalculationDetailDialog.vue";
import EffContractTeacherDataCard from "../components/TeacherPage/EffContractTeacherDataCard.vue";

export default {
  name: "EffectiveContractsTeacherPage",
  components: {
    EffContractTeacherDataCard,
    EffectiveContractAutoCalculationDetailDialog,
    Loading,
    PersonEffConDialog,
    EffConTable
  },

  data() {
    return {
      tab: 0,
      dialogOrder: true,
      loading: true,
      personEffContractId: null,
      autoCalculateDetailDialog: false,
    };
  },

  computed: {
    ...mapState({
      effConOrder: state => state.effective_contract.payloadOrder,
      orderPresent: state => state.effective_contract.orderPresent,
      personEffContracts: state => state.effective_contract.personEffContracts,
      teachersList: state => state.effective_contract.teachersList,
    }),

    ...mapGetters({
      isDean: "effective_contract/isDean",
      isHeadDepartment: "effective_contract/isHeadDepartment",
    }),
  },

  async mounted() {
    await this.getEffConOrder();
    if (!this.orderPresent) {
      this.$router.push("/effective_contracts/app/order");
    } else {
      await Promise.all([this.getEffContracts(), this.getPersonEffContracts()])
      this.multiplicationByPlanRate();

      if (this.personEffContracts.length === 0) {
        this.autoCalculateFactsAction();
      }

      this.loading = false;
    }
  },

  methods: {
    ...mapActions({
      getEffConOrder: "effective_contract/getEffConOrder",
      sendEffContract: "effective_contract/sendEffContract",
      getEffContracts: "effective_contract/getEffContracts",
      getPersonEffContracts: "effective_contract/getPersonEffContracts",
      multiplicationByPlanRate: "effective_contract/multiplicationByPlanRate",
      autoCalculateFactsAction: "effective_contract/autoCalculateFactsAction",

      successSnackbarAction: 'effective_contract_notification_snackbar/successSnackbarAction',
      errorSnackbarAction: 'effective_contract_notification_snackbar/errorSnackbarAction',
    }),

    openAutoCalculateDialog(id) {
      this.personEffContractId = id;
      this.autoCalculateDetailDialog = true;
    },

    closeAutoCalculateDetailDialog() {
      this.personEffContractId = null;
      this.autoCalculateDetailDialog = false;
    }
  }

}
</script>

<template>
  <v-card class="pa-0 ma-0" flat>
    <loading :loading="loading">

      <eff-contract-teacher-data-card/>

      <v-tabs
        v-model="tab"
        centered
        color="teal darken-3"
        icons-and-text
        v-show="isDean || isHeadDepartment"
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-1">
          Ставка
        </v-tab>

        <v-tab href="#tab-2" v-if="isHeadDepartment">
          Заведующий кафедрой
        </v-tab>

        <v-tab href="#tab-3" v-if="isDean">
          Декан
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item :key="'tab-1'" :value="'tab-1'">
          <v-card flat>
            <v-card-text>
              <eff-con-table
                :type-basic-contract="'bidBasic'"
                :type-stimulating-contract="'bidStimulating'"
                @open-auto-calculate-dialog="openAutoCalculateDialog"
              />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="'tab-2'" :value="'tab-2'" v-if="isHeadDepartment">
          <v-card flat>
            <v-card-text>
              <eff-con-table
                :type-basic-contract="'headDepartmentBasic'"
                :type-stimulating-contract="'headDepartmentStimulating'"
                @open-auto-calculate-dialog="openAutoCalculateDialog"
              />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="'tab-3'" :value="'tab-3'" v-if="isDean">
          <v-card flat>
            <v-card-text>
              <eff-con-table
                :type-basic-contract="'deanBasic'"
                :type-stimulating-contract="'deanStimulating'"
                @open-auto-calculate-dialog="openAutoCalculateDialog"
              />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <effective-contract-auto-calculation-detail-dialog
        :dialog="autoCalculateDetailDialog"
        :person-eff-contract-id="personEffContractId"
        @close="closeAutoCalculateDetailDialog"
      />
      <person-eff-con-dialog/>
    </loading>
  </v-card>
</template>

<style scoped>

</style>